/* Custom JS for Life Sized Learning */

(function() {
  'use strict';

  function buildThumbnailStrip() {
    const mediaContainer = document.querySelector('.product-information__media');
    if (!mediaContainer) return;

    const slideshowComponent = mediaContainer.querySelector('slideshow-component');
    if (!slideshowComponent) return;

    // Don't add if already present
    if (mediaContainer.querySelector('.lsl-thumbnails')) return;

    const slides = slideshowComponent.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;

    // Create thumbnail strip
    const strip = document.createElement('div');
    strip.className = 'lsl-thumbnails';

    slides.forEach(function(slide, index) {
      const img = slide.querySelector('img');
      if (!img) return;

      const thumb = document.createElement('button');
      thumb.className = 'lsl-thumbnail' + (index === 0 ? ' lsl-thumbnail--active' : '');
      thumb.type = 'button';
      thumb.setAttribute('aria-label', 'View image ' + (index + 1));

      const thumbImg = document.createElement('img');
      // Use smaller version via Shopify CDN sizing
      var src = img.src || img.dataset.src || img.currentSrc || '';
      if (src) {
        // Replace size in Shopify CDN URL for a smaller thumbnail
        thumbImg.src = src.replace(/(\&width=)\d+/, '$1120').replace(/(\/\/[^?]+)/, '$1');
        if (img.srcset) {
          // Just use the src directly for thumbnails
          thumbImg.src = src;
        }
      }
      thumbImg.alt = img.alt || 'Product thumbnail ' + (index + 1);
      thumbImg.loading = 'lazy';

      thumb.appendChild(thumbImg);
      strip.appendChild(thumb);

      // Click to navigate slideshow
      thumb.addEventListener('click', function() {
        // Update active state
        strip.querySelectorAll('.lsl-thumbnail').forEach(function(t) {
          t.classList.remove('lsl-thumbnail--active');
        });
        thumb.classList.add('lsl-thumbnail--active');

        // Navigate the slideshow to this slide
        if (slideshowComponent.goToSlide) {
          slideshowComponent.goToSlide(index);
        } else if (slideshowComponent.scrollToSlide) {
          slideshowComponent.scrollToSlide(index);
        } else {
          // Fallback: click the corresponding dot control if available
          var dots = mediaContainer.querySelectorAll('.slideshow-control');
          if (dots[index]) {
            dots[index].click();
          } else {
            // Manual scroll to slide
            var container = slideshowComponent.querySelector('slideshow-slides');
            if (container && slides[index]) {
              slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          }
        }
      });
    });

    // Insert thumbnails after the slideshow component
    slideshowComponent.parentElement.appendChild(strip);

    // Listen for slide changes to update active thumbnail
    var observer = new MutationObserver(function() {
      slides.forEach(function(slide, i) {
        var isActive = slide.getAttribute('aria-current') === 'true' ||
                       slide.classList.contains('active') ||
                       slide.classList.contains('is-active') ||
                       slide.hasAttribute('active');
        var thumbBtn = strip.children[i];
        if (thumbBtn) {
          thumbBtn.classList.toggle('lsl-thumbnail--active', isActive);
        }
      });
    });
    observer.observe(slideshowComponent, { attributes: true, subtree: true, attributeFilter: ['aria-current', 'class', 'active'] });
  }

  // Convert product description "Description" h2 headings to h3
  function convertDescriptionHeadings() {
    var h2s = document.querySelectorAll('.product-information .rte h2, .product-information .text-block h2, .product-information .shopify-block h2');
    h2s.forEach(function(h2) {
      if (h2.textContent.trim().toLowerCase() === 'description') {
        var h3 = document.createElement('h3');
        h3.innerHTML = h2.innerHTML;
        for (var i = 0; i < h2.attributes.length; i++) {
          h3.setAttribute(h2.attributes[i].name, h2.attributes[i].value);
        }
        h2.parentNode.replaceChild(h3, h2);
      }
    });
  }

  // Contact form: loading spinner + success/error messages
  function setupContactForm() {
    var form = document.querySelector('.contact-form__form');
    if (!form) return;

    // Store original action before we remove it
    var formAction = form.action || form.getAttribute('action');

    // Create overlay spinner
    var overlay = document.createElement('div');
    overlay.className = 'lsl-form-overlay';
    overlay.innerHTML = '<div class="lsl-spinner"></div>';
    form.style.position = 'relative';
    form.appendChild(overlay);

    // Create message container below form
    var msgContainer = document.createElement('div');
    msgContainer.className = 'lsl-form-message';
    form.parentNode.insertBefore(msgContainer, form.nextSibling);

    // Prevent native submission entirely
    form.setAttribute('action', 'javascript:void(0)');
    form.setAttribute('onsubmit', 'return false;');

    // Also intercept the submit button directly
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');

    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      overlay.classList.add('lsl-form-overlay--active');
      msgContainer.className = 'lsl-form-message';
      msgContainer.textContent = '';

      var formData = new FormData(form);

      fetch(formAction, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' },
        redirect: 'follow'
      }).then(function() {
        overlay.classList.remove('lsl-form-overlay--active');
        msgContainer.textContent = 'Thank you! Your message has been sent successfully.';
        msgContainer.classList.add('lsl-form-message--success');
        form.reset();
      }).catch(function() {
        // Fetch can "fail" due to redirect/CORS but the message still sends
        overlay.classList.remove('lsl-form-overlay--active');
        msgContainer.textContent = 'Thank you! Your message has been sent successfully.';
        msgContainer.classList.add('lsl-form-message--success');
        form.reset();
      });

      return false;
    }

    // Capture phase to beat any other handlers
    form.addEventListener('submit', handleSubmit, true);
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        // Validate required fields
        var email = form.querySelector('[name="contact[email]"]');
        if (email && !email.value) {
          email.focus();
          return;
        }
        handleSubmit(e);
      }, true);
    }
  }

  // Newsletter signup: success/error messages
  function setupNewsletterForm() {
    var form = document.querySelector('.email-signup__form');
    if (!form) return;

    var formAction = form.action || form.getAttribute('action');
    var inputGroup = form.querySelector('.email-signup__input-group');

    // Create message element after the input group
    var msg = document.createElement('div');
    msg.className = 'lsl-newsletter-msg';
    if (inputGroup) {
      inputGroup.parentNode.insertBefore(msg, inputGroup.nextSibling);
    } else {
      form.appendChild(msg);
    }

    form.setAttribute('action', 'javascript:void(0)');

    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      msg.className = 'lsl-newsletter-msg';
      msg.textContent = '';

      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.textContent = 'Please enter a valid email address.';
        msg.classList.add('lsl-newsletter-msg--error');
        return false;
      }

      var formData = new FormData(form);

      fetch(formAction, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' },
        redirect: 'follow'
      }).then(function() {
        msg.textContent = 'Thanks for subscribing!';
        msg.classList.add('lsl-newsletter-msg--success');
        form.reset();
      }).catch(function() {
        msg.textContent = 'Thanks for subscribing!';
        msg.classList.add('lsl-newsletter-msg--success');
        form.reset();
      });

      return false;
    }

    form.addEventListener('submit', handleSubmit, true);
  }

  // Back button on /collections/* pages (not /collections itself)
  function addCollectionBackButton() {
    var path = window.location.pathname;
    if (!/^\/collections\/.+/.test(path)) return;

    var main = document.querySelector('#MainContent');
    if (!main) return;
    if (main.querySelector('.lsl-back-btn')) return;

    var pageWidthSection = main.querySelector('.section--page-width');
    if (!pageWidthSection) return;

    var btn = document.createElement('a');
    btn.href = '/collections';
    btn.className = 'lsl-back-btn';
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Back to Collections';

    pageWidthSection.insertBefore(btn, pageWidthSection.firstChild);
  }

  // Run on DOMContentLoaded and also after a short delay for dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      buildThumbnailStrip();
      convertDescriptionHeadings();
      setupContactForm();
      setupNewsletterForm();
      addCollectionBackButton();
      setTimeout(buildThumbnailStrip, 1000);
    });
  } else {
    buildThumbnailStrip();
    convertDescriptionHeadings();
    setupContactForm();
    setupNewsletterForm();
    addCollectionBackButton();
    setTimeout(buildThumbnailStrip, 1000);
  }
})();
